export default "__VITE_ASSET__Cao01YC0__"